import { defineComponent as t, onBeforeMount as s, createBlock as n, openBlock as a, unref as o, withCtx as l, createVNode as r } from "vue";
import { addScalarClassesToHeadless as c, ScalarModal as y } from "@scalar/components";
import p from "./TypesenseSearch.vue.js";
const C = /* @__PURE__ */ t({
  __name: "Search",
  props: {
    modalState: {},
    typesenseKey: {},
    typesenseHost: {},
    typesenseCollection: {}
  },
  setup(e) {
    return s(() => c()), (i, m) => (a(), n(o(y), {
      "aria-label": "Reference Search",
      state: e.modalState,
      variant: "search"
    }, {
      default: l(() => [
        r(p, {
          typesenseCollection: e.typesenseCollection,
          typesenseHost: e.typesenseHost,
          typesenseKey: e.typesenseKey
        }, null, 8, ["typesenseCollection", "typesenseHost", "typesenseKey"])
      ]),
      _: 1
    }, 8, ["state"]));
  }
});
export {
  C as default
};
